export const trim = <T>(arr: Array<T>, toDrop: T) => {
  let start = 0;
  let end = arr.length;
  while (arr[start] === toDrop) {
    start++;
  }
  while (arr[end - 1] === toDrop) {
    end--;
  }

  return arr.slice(start, end);
};
